import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const cache = new Map();

export function useTranslations(words) {
  const { user } = useAuth();
  const lang = user?.native_language;
  const list = words.map((w) => w.word);
  const sig = `${lang}|${list.join("|")}`;
  const [map, setMap] = useState({});

  useEffect(() => {
    if (!lang || !list.length) return setMap({});
    const missing = list.filter((w) => !cache.has(`${lang}|${w}`));
    const fill = () => setMap(Object.fromEntries(list.map((w) => [w, cache.get(`${lang}|${w}`)]).filter(([, t]) => t)));
    if (!missing.length) return fill();
    let alive = true;
    api.post("/translations", { words: missing.slice(0, 30) })
      .then((r) => {
        Object.entries(r.data).forEach(([w, t]) => cache.set(`${lang}|${w}`, t));
        if (alive) fill();
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [sig]); // eslint-disable-line react-hooks/exhaustive-deps

  return { map, rtl: lang === "ar" };
}

export function Translation({ text, rtl, testId, className = "" }) {
  if (!text) return null;
  return (
    <span dir={rtl ? "rtl" : "ltr"} data-testid={testId} className={`inline-block rounded-md bg-sky-100 text-sky-900 px-2 py-0.5 text-sm font-semibold ${className}`}>
      {text}
    </span>
  );
}
